var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_557_684)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#FFEFD7",
    stroke: "#D9A62E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.125 29.585C31.0687 29.5851 38.9373 31.5645 38.9375 35.4912V38.7725H15.3125V35.4912C15.3127 31.5645 23.1824 29.5851 27.125 29.585ZM27.126 16.625C30.026 16.6252 32.3758 18.976 32.376 21.875C32.376 24.7741 30.0251 27.1257 27.126 27.126C24.2267 27.126 21.875 24.7754 21.875 21.875C21.8752 18.9748 24.2268 16.625 27.126 16.625Z",
    fill: "url(#paint0_linear_557_684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.125 29.585C31.0687 29.5851 38.9373 31.5645 38.9375 35.4912V38.7725H15.3125V35.4912C15.3127 31.5645 23.1824 29.5851 27.125 29.585ZM27.126 16.625C30.026 16.6252 32.3758 18.976 32.376 21.875C32.376 24.7741 30.0251 27.1257 27.126 27.126C24.2267 27.126 21.875 24.7754 21.875 21.875C21.8752 18.9748 24.2268 16.625 27.126 16.625Z",
    stroke: "#DEA829"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_557_684",
    x1: 15.3125,
    y1: 27.6988,
    x2: 38.9375,
    y2: 27.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_557_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerInfo);
export default __webpack_public_path__ + "static/media/customer_info.fb3002a952449e790d3f2ab240950d81.svg";
export { ForwardRef as ReactComponent };